import {ChangeDetectionStrategy, Component, Inject, OnInit, Optional, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {PoisService} from '../../../../provider/pois.service';
import {ItemPopup} from '../item/item.popup';
import {MenuCategoryModel} from '../../../models/menu-category.model';
import {MenuSectionService} from '../../../../provider/menu-section.service';
import {ItemService} from '../../../../provider/item.service';

@Component({
  selector: 'kt-pois',
  templateUrl: './pois.popup.html',
  styleUrls: ['./pois.popup.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PoisPopup implements OnInit {
  selectedIndex = -1;
  datas = [];
  range: number;
  loading = true;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public dialog: MatDialog,
              public poisService: PoisService,
              public itemRef: MatDialogRef<ItemPopup>,
              public sectionService: MenuSectionService,
              private itemService: ItemService) {

    this.poisService.record_change$.subscribe(
      resp => {
        if (resp.length != 0) {
          this.loading = false;
        }
      }
    );

    if (localStorage.getItem('range') == null) {
      this.range = 3000;
    } else {
      this.range = +localStorage.getItem('range');
    }
  }

  newPOIs() {
    const dialogRef = this.dialog.open(ItemPopup, {width: '1400px'});
    dialogRef.afterClosed().subscribe(result => {
      if (!(result == false || result == undefined)) {
        console.log(result);
        this.itemRef.close();
        if (result.ImageDatas.length > 0) {
          result.Item.image_url = result.ImageDatas[0].attachment_url;
        }
        const nSub = this.sectionService.addCategoryRet('Others', this.data).subscribe(
          (data: MenuCategoryModel) => {

            this.sectionService.setPoisItems([result.Item], data.id, this.data).subscribe(
              (item) => {
                this.sectionService.getDatas(this.data);
                result.TagDatas.forEach(x => {
                  x.table_record_id = item[0].id;
                  this.itemService.postTagData(x);
                });
              }
            );
          },
          (err) => console.log(err),
          () => {

          }
        );
      }
    });
  }

  OnChange() {
    this.selectedIndex = -1;
    localStorage.setItem('range', this.range.toString());
    this.poisService.googlePlaceApi(this.range);
    this.loading = true;
  }

  ngOnInit(): void {
  }
}
